module.exports = __webpack_public_path__ + "static/media/btn_strava_connectwith_orange.aa0d255c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/Strava/btn_strava_connectwith_orange.svg
// module id = 242
// module chunks = 2